import * as _ from 'lodash';

class DataCacheService {
    /*@ngInject*/
    constructor(constants, CacheFactory) {
        let cache = CacheFactory.get('fpActivationsWizard');
        if (_.isNil(cache)) {
            CacheFactory.createCache('fpActivationsWizard', {
                storageMode: 'memory', // sessionStorage
                deleteOnExpire: 'aggressive',
                cacheFlushInterval: constants.cacheRefreshInterval
            });
        }

        this.instance = CacheFactory.get('fpActivationsWizard');
    }

    clear() {
        this.instance.removeAll();
    }
}

export default DataCacheService;